<script>
import http from '@/service/http'
import {mapState} from 'vuex'

export default {
  name: 'Form',
  data () {
    return {
      arte: {
        id: '',
        arte: '',
        descricao: '',
        imagem: ''
      },
      progress: 0,
      progress2: 0,
      errorFile: false,
      errorFile2: false,
      options: {
        url: `${process.env.API_URL}/upload-file`,
        uploadMultiple: false,
        parallelUploads: 1,
        headers: {
          path: 'artes',
          width: 6000,
          height: 6000,
          accept: 'all'
        }
      }
    }
  },
  mounted () {
    this.fecth()
  },
  watch: {
    '$route' () {
      if (this.$route.params.id != null) {
        this.fecth()
      }
    },
    hasAll () {
      if (this.hasAll) {
        this.all = true
      } else {
        this.all = false
      }
    }
  },
  methods: {
    validate () {
      this.$validator.validateAll().then(success => {
        if (!success) {
          this.$swal({
            title: 'Ops, encontramos um erro!',
            html: 'Um ou mais campos estão com seu preenchimento incorreto',
            type: 'error',
            cancelButtonText: 'Ok'
          })
          return false
        } else {
          this.submit()
        }
      })
    },
    async submit () {
      const verb = this.isNew ? 'post' : 'put'
      const url = this.isNew ? '/artes' : `/artes/${this.arte.id}`
      const {data} = await http[verb](url, this.arte)
      if (data != null) {
        this.$emit('update-artes-list', {arte: data.arte})
        this.$router.push({name: 'artes.index'})
      }
    },
    async fecth () {
      this.clear()
      const {id} = this.$route.params
      if (id !== undefined) {
        const {data} = await http.get(`/artes/${id}/edit`)
        this.arte = data.arte
        setTimeout(function () {
          window.Materialize.updateTextFields()
        }, 0)
      }
    },
    clear () {
      this.arte = {
        id: '',
        arte: '',
        descricao: '',
        imagem: ''
      }
    },
    totalProgress (progress, totalBytes, bytesSent) {
      this.progress = progress
    },
    complete2 (file, status, xhr) {
      if (file.errorMessage) {
        this.errorFile = true
      } else {
        this.errorFile = false
        file.addAttribute('id', xhr.response.id)
        this.arte.imagem = xhr.response
        this.progress = 0
      }
    }
  },
  computed: {
    ...mapState(['loading']),
    isNew () {
      return this.arte.id === ''
    },
    api_url () {
      return process.env.UPLOADS_URL
    },
    url_app () {
      return process.env.API_URL
    }
  }
}
</script>

<template>
  <div>

    <form @submit.prevent="validate">

      <div class="row">

        <div class="col s12 m10 offset-m1">

          <div class="row">
            <div class="input-field col s12">
              <input name="arte" id="arte" type="text" v-validate
                     data-vv-rules="required" :class="{invalid: errors.has('arte')}"
                     v-model="arte.arte">
              <label for="arte">*Arte</label>
              <small class="red-text">{{ errors.first('arte') }}</small>
            </div>
          </div>

          <div class="row">
            <div class="input-field col s12">
              <textarea name="descricao" id="descricao" v-model="arte.descricao" class="materialize-textarea"></textarea>
              <label for="arte">Descrição</label>
            </div>
          </div>

          <div class="row">

            <div class="col s12 m4">

              <vue-clip :options="options" :on-complete="complete2" :on-total-progress="totalProgress">
                <template slot="clip-uploader-action">
                  <div class="row">
                    <div class="col s12">
                      <div class="dz-message">
                        <div class="card">
                          <span class="card-title">Arquivo</span>
                          <div class="center-align" style="height: 100px; width: 100%;">
                            <div>
                              <small class="center-align">clique para inserir um arquivo</small>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="progress">
                        <div class="determinate" :style="`width: ${progress}%`"></div>
                      </div>
                      <div v-if="errorFile" class="center-align">Tipo de arquivo inválido</div>
                    </div>
                  </div>
                </template>
              </vue-clip>

            </div>

            <div class="col s12 m4">
              <div class="col s12 center" v-if="arte.imagem">
                <p class=" center">Clique para baixar</p>
                <a :href="`${api_url}/artes/${arte.imagem}`" download="" target="_blank" class="btn-floating waves-effect waves-light" ><i
                  class="material-icons">file_download</i></a>
                <div class="center-align" style="display: none">
                  <br clear="all" />
                  <br clear="all" />
                  <i class="material-icons pointer" @click.prevent="destroyImage()">delete_forever</i></div>
              </div>
            </div>

          </div>

          <div class="row">

            <div class="input-field col s12">
              <button class="waves-effect waves-light btn" :disabled="loading">Salvar</button>
            </div>

          </div>

        </div>

      </div>

    </form>

  </div>
</template>



// WEBPACK FOOTER //
// src/features/artes/form.vue